// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import IdleVue from 'idle-vue'

// Components
import './components'

// Plugins
// import './plugins'
import './plugins/axios'
import './plugins/chartist'

// Sync router with store
import { sync } from 'vuex-router-sync'
import { abilitiesPlugin } from '@casl/vue'


// Application imports
import App from './App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

import Default from './layouts/Default.vue'
import NoSidebar from './layouts/NoSidebar.vue'
import NoSidebarNoFooter from './layouts/NoSidebarNoFooter.vue'
import TokenAuth from './layouts/TokenAuth.vue'
import AsyncComputed from 'vue-async-computed'

import { getInfo } from './api/user.js'

import '@/permission' // permission control
import vuetify from './plugins/vuetify';
Vue.config.productionTip = false

const eventsHub = new Vue()
Vue.use(IdleVue, { eventEmitter: eventsHub, idleTime: 1000 * 60 * 30 })
Vue.use(abilitiesPlugin, store.getters.ability)

Vue.component('default-layout', Default)
Vue.component('no-sidebar-layout', NoSidebar)
Vue.component('no-sidebar-no-footer-layout', NoSidebarNoFooter)
Vue.component('token-auth-layout', TokenAuth)
Vue.use(AsyncComputed)



import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
 
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyCMjMUWOmACo34kvtCuFPgQ35z1OdWEtwc', 
  language: 'IT', // Optional
});

// Sync store with router
sync(store, router)

/* eslint-disable no-new */
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
  onIdle () {
    router.push({ path: '/logout' })
  },
  onActive () {
    getInfo()
  }
}).$mount('#app')
